 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"runtime": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"channel":"channel","channel-customer-list":"channel-customer-list","npm.buffer":"npm.buffer","npm.quill":"npm.quill","npm.vue-cropper":"npm.vue-cropper","staff":"staff","npm.vue-json-viewer":"npm.vue-json-viewer","npm.clipboard":"npm.clipboard","basic":"basic","npm.qrcode.vue":"npm.qrcode.vue","npm.vue-pdf":"npm.vue-pdf"}[chunkId]||chunkId) + "." + {"channel":"a34db463","channel-customer-list":"8ef8460d","chunk-0d7b9943":"020c7220","chunk-0f87d386":"d7810d38","chunk-1461ec17":"4ddd531c","chunk-17e0fc5d":"a961ee2e","chunk-19567953":"6324f052","chunk-1a39e760":"ea4d51a3","chunk-213643a9":"a21c8306","chunk-2723f098":"f2d8d8c0","chunk-2d0b3115":"32e4d90c","chunk-2d0b696a":"5a1a06fb","chunk-2d0c11d3":"06ec2c63","chunk-2d0c206c":"00d1dd69","chunk-2d0e62c4":"e4414c44","chunk-2d0f07d4":"cf7dc629","chunk-2d20ee14":"6cff399e","chunk-40d79ac4":"7e7200a6","chunk-423761b4":"0ba62c7c","chunk-45735fc9":"c239c79f","chunk-4b1e9fff":"3b14496a","chunk-4bcfc7d2":"b00bb3a1","chunk-4f58126d":"ebc2a688","chunk-581bdf19":"a0999964","chunk-6578b4db":"054bc832","chunk-9ed65c38":"46de794c","chunk-b58e61fa":"f11b5dea","chunk-c59d66fa":"95067165","chunk-d0f4f926":"6b147eeb","chunk-d9049b20":"138740e3","chunk-da8abd46":"a1788005","chunk-fbd1250c":"6229e2cd","npm.buffer":"57b5627a","npm.quill":"30aee1c8","chunk-0ec9acd1":"c737ca85","npm.vue-cropper":"1980ab11","staff":"51882183","npm.vue-json-viewer":"de3a9afe","npm.clipboard":"9a39a4cb","basic":"81bd7abc","npm.qrcode.vue":"f59f3c05","chunk-320b0969":"f5ea06c4","chunk-5232995b":"847f5795","npm.vue-pdf":"04a02210","chunk-3e187f2a":"202016d8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"channel-customer-list":1,"chunk-0d7b9943":1,"chunk-0f87d386":1,"chunk-1461ec17":1,"chunk-17e0fc5d":1,"chunk-19567953":1,"chunk-1a39e760":1,"chunk-213643a9":1,"chunk-2723f098":1,"chunk-40d79ac4":1,"chunk-423761b4":1,"chunk-45735fc9":1,"chunk-4b1e9fff":1,"chunk-4bcfc7d2":1,"chunk-4f58126d":1,"chunk-581bdf19":1,"chunk-6578b4db":1,"chunk-9ed65c38":1,"chunk-b58e61fa":1,"chunk-c59d66fa":1,"chunk-d0f4f926":1,"chunk-d9049b20":1,"chunk-da8abd46":1,"chunk-fbd1250c":1,"npm.quill":1,"chunk-0ec9acd1":1,"staff":1,"basic":1,"chunk-320b0969":1,"chunk-5232995b":1,"npm.vue-pdf":1,"chunk-3e187f2a":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"channel":"channel","channel-customer-list":"channel-customer-list","npm.buffer":"npm.buffer","npm.quill":"npm.quill","npm.vue-cropper":"npm.vue-cropper","staff":"staff","npm.vue-json-viewer":"npm.vue-json-viewer","npm.clipboard":"npm.clipboard","basic":"basic","npm.qrcode.vue":"npm.qrcode.vue","npm.vue-pdf":"npm.vue-pdf"}[chunkId]||chunkId) + "." + {"channel":"31d6cfe0","channel-customer-list":"993e68e3","chunk-0d7b9943":"ca723cf8","chunk-0f87d386":"9c02c8d0","chunk-1461ec17":"802d0cac","chunk-17e0fc5d":"7e3fd3d7","chunk-19567953":"59358792","chunk-1a39e760":"663adb94","chunk-213643a9":"411f3ad3","chunk-2723f098":"a338fc83","chunk-2d0b3115":"31d6cfe0","chunk-2d0b696a":"31d6cfe0","chunk-2d0c11d3":"31d6cfe0","chunk-2d0c206c":"31d6cfe0","chunk-2d0e62c4":"31d6cfe0","chunk-2d0f07d4":"31d6cfe0","chunk-2d20ee14":"31d6cfe0","chunk-40d79ac4":"03bfd787","chunk-423761b4":"5d3f1bb9","chunk-45735fc9":"75ab88cf","chunk-4b1e9fff":"20575df0","chunk-4bcfc7d2":"b7f57a97","chunk-4f58126d":"d18fd208","chunk-581bdf19":"865a64f5","chunk-6578b4db":"36db05e6","chunk-9ed65c38":"90a44921","chunk-b58e61fa":"d3571922","chunk-c59d66fa":"f24ed2da","chunk-d0f4f926":"56e298fe","chunk-d9049b20":"3b8dd1ad","chunk-da8abd46":"663badf1","chunk-fbd1250c":"2f4f4eb5","npm.buffer":"31d6cfe0","npm.quill":"a2435f9a","chunk-0ec9acd1":"fa7e9384","npm.vue-cropper":"31d6cfe0","staff":"c460ed29","npm.vue-json-viewer":"31d6cfe0","npm.clipboard":"31d6cfe0","basic":"194d1680","npm.qrcode.vue":"31d6cfe0","chunk-320b0969":"514bab2b","chunk-5232995b":"cf17bb8c","npm.vue-pdf":"27b45427","chunk-3e187f2a":"654aacf1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
